const Footer = () => {
  return (
    <footer className="Footer">
      <div>Made with ❤ by <a href="https://ronkiro.github.io">Alexander Santos (Ronkiro)</a></div>
      <nav>
        <a href="https://github.com/ronkiro"><i className="fa fa-github"></i></a>
        <a href="https://linkedin.com/in/ronkiro"><i className="fa fa-linkedin"></i></a>
        <a href="https://codepen.io/ronkiro"><i className="fa fa-codepen"></i></a>
        <a href="mailto:dev_alex@outlook.com"><i className="fa fa-envelope"></i></a>
        <a href="https://stackoverflow.com/users/10473393/alexander-santos"><i className="fa fa-stack-overflow"></i></a>
      </nav>
    </footer>
  );
};

export default Footer;